__turbopack_context__.v({
  "card": "from-cell-to-brain-module__vM0e8q__card",
  "cardHeader": "from-cell-to-brain-module__vM0e8q__cardHeader",
  "column": "from-cell-to-brain-module__vM0e8q__column",
  "description": "from-cell-to-brain-module__vM0e8q__description",
  "image": "from-cell-to-brain-module__vM0e8q__image",
  "widgetFromCellToBrain": "from-cell-to-brain-module__vM0e8q__widgetFromCellToBrain",
});
